import { useState, useContext } from "react";
import AuthContext from "../../../contexts/auth";
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
// icons
import * as MdIcons from 'react-icons/md';
// components
import Spinner from "../../../components/Spinner";
import { translate } from "../../../utils/Common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FormForgotPwd = ({ setForgotPwdSuccess }) => {
    const userContext = useContext(AuthContext);
    const { register, handleSubmit, reset, setError, errors } = useForm();

    // to handle server response
    const [isLoading, setIsLoading] = useState(null);

    const onSubmit = async (data) => {
        try {
            if (data.email.includes('@') && data.email.includes('.')) {
                setIsLoading(true);
                const result = await userContext.forgotPwd(data);
                setIsLoading(false);

                switch (result) {
                    case 'EMAIL_SENT_SUCCESSFULLY':
                        reset();
                        setForgotPwdSuccess(true);
                        break;
                    case 'EMAIL_IS_NEEDED':
                        setError('email', { type: '', message: translate("login.forgotpwd.validate.emailNeeded") });
                        break;
                    case 'INVALID_EMAIL':
                        setError('email', { type: '', message: translate("login.forgotpwd.validate.emailInvalid") });
                        break;
                    case 'EMAIL_NOT_FOUND':
                        setError('email', { type: '', message: translate("login.forgotpwd.validate.emailNotFound") });
                        break;
                    case 'CLIENT_IS_INACTIVE':
                        setError('email', { type: '', message: translate("login.forgotpwd.validate.clientInactive") });
                        break;
                    case 'ERROR':
                        setError('email', { type: '', message: translate("login.forgotpwd.validate.errorServer") });
                        break;

                    default:
                        break;
                }
            }
            else {
                setError('email', { type: '', message: translate("login.forgotpwd.validate.emailError") });
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <h2 className="text-center text-lg font-semibold tracking-tight text-foreground">
                {translate("login.forgotpwd.title")}
            </h2>
            <p className="mt-2 text-center text-sm text-muted-foreground">
                {translate("login.forgotpwd.instructions")}
            </p>

            <div className="mt-6 space-y-1.5">
                <Label htmlFor="inputEmail">
                    <span className="text-destructive">*</span> {translate("login.forgotpwd.email")}
                </Label>
                <div className="relative">
                    <MdIcons.MdEmail
                        size={18}
                        aria-hidden="true"
                        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
                    />
                    <Input
                        type="email"
                        id="inputEmail"
                        name="email"
                        autoComplete="email"
                        required
                        aria-invalid={errors.email ? "true" : "false"}
                        className="pl-10"
                        ref={register({ required: true })}
                    />
                </div>
                {errors.email && (
                    <p className="text-xs font-medium text-destructive">{errors.email.message}</p>
                )}
            </div>

            <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row">
                <Button asChild variant="outline" size="lg" className="flex-1">
                    <Link to="/login">{translate("login.forgotpwd.buttonReturn")}</Link>
                </Button>
                <Button type="submit" size="lg" className="flex-1">
                    { !isLoading ? translate("login.forgotpwd.buttonSend") : <Spinner type={1} size={18} /> }
                </Button>
            </div>
        </form>
    );
}

export default FormForgotPwd;
